import React from "react";
import {useFormik} from "formik";
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField/TextField";
import Button from "@mui/material/Button";


const TextAttributeForm = (props) => {
    const {
        attribute,
        label,
        value,
        defaultValue = "",
        validationSchema,
        onClose,
        onSubmit,
        disableRequired,
        isLoading,
        dialogTitle,
        ...textFieldProps
    } = props

    const formik = useFormik({
        initialValues: {[attribute]: value == null ? defaultValue : value },
        validationSchema: validationSchema,
        validateOnMount: true,
        onSubmit: onSubmit,
    });

    return <Dialog onClose={onClose} open={true} fullWidth>
        <DialogTitle>
            {dialogTitle ? dialogTitle : `Aggiorna ${label.toLowerCase()}`}
        </DialogTitle>
        <DialogContent>
            <TextField label={label}
                       fullWidth
                       name={attribute}
                       required={!disableRequired}
                       autoFocus
                       value={formik.values[attribute]}
                       onChange={formik.handleChange}
                       error={formik.touched[attribute] && Boolean(formik.errors[attribute])}
                       helperText={formik.touched[attribute] && formik.errors[attribute]}
                       sx={{mt: 2}}
                       {...textFieldProps} />
        </DialogContent>
        <DialogActions sx={{py: 2, px: 3}}>
            <Button color={"primary"}
                    variant={"text"}
                    onClick={onClose}>
                Cancella
            </Button>
            <LoadingButton onClick={() => formik.handleSubmit()}
                           loading={!!isLoading}
                           variant="contained">
                Salva
            </LoadingButton>
        </DialogActions>
    </Dialog>
}


TextAttributeForm.propTypes = {
    attribute: PropTypes.string.isRequired,  // Name of the attribute (it will be passed in an object when submit is called)
    label: PropTypes.string.isRequired,  // Label of the attribute shown
    value: PropTypes.any,  // Initial value of the attribute
    defaultValue: PropTypes.object,  // Default value of the value
    validationSchema: PropTypes.object,  // Validation schema for the attribute
    onClose: PropTypes.func.isRequired,  // Function called when closing the form
    onSubmit: PropTypes.func.isRequired,  // Function called when submitting the form
    disableRequired: PropTypes.bool, //remove the asterisk on the TextField
    isLoading: PropTypes.bool,
    dialogTitle: PropTypes.string,
};

export default TextAttributeForm;